import { render } from "./NominateVoteView.vue?vue&type=template&id=35562a74&scoped=true"
import script from "./NominateVoteView.vue?vue&type=script&lang=js"
export * from "./NominateVoteView.vue?vue&type=script&lang=js"

import "./NominateVoteView.vue?vue&type=style&index=0&id=35562a74&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35562a74"]])

export default __exports__